export default function PrivacyPolicyContent() {
  return (
    <>
      <strong>ABOUT LIFE™</strong>
      <br />
      OnePIN's Life service enables users to effortlessly stay connected by
      exchanging and saving rich digital contact cards directly to their
      phonebooks. These customizable cards can include photos, mobile numbers,
      addresses, birthdays, work details, social media links, and any other
      personal or professional information users choose to share. Designed for
      seamless connection with friends, family, customers, and colleagues, Life
      ensures that contact information is always up-to-date and readily
      accessible, making relationship management easier and more dynamic.
      <br />
      <br />
      <strong>WHAT PERSONAL INFORMATION IS COLLECTED FROM YOU</strong>
      <br />
      The Mobile Network Operator offers the Life Service to their mobile
      subscribers in their network. Subscribers are given opportunities to
      opt-in (register) to the service during normal mobile phone use (e.g. at
      handset start-up, after phone calls are ended, etc.). If the mobile
      subscriber does not wish to opt-in at the time of these offers, the
      service will not be available to them. When opting-in with OnePIN’s Life
      service the mobile subscriber is asked for a first name, last name
      (optional), mobile number (MSISDN obtained from the network), telephone
      number (optional), e-mail address (optional), photo (optional), birthday
      (optional), title (Mr. Mrs. Ms. Miss, etc.) and social media addresses
      (optional) as part of the profile setup process. Once a name is provided
      by the user, mobile subscribers may then elect to use OnePIN’s Life
      service after phone calls. OnePIN will only collect and display contact
      information exactly as it is entered and saved by subscribers. OnePIN does
      not collect or display other personal information (such as race, religion,
      political affiliation or sexual orientation). OnePIN does not knowingly
      collect personal information on children. Subscribers are given the
      opportunity to send their Life business card to another mobile subscriber
      after the first call is dialed and has ended with the other subscriber.
      The service adheres to mobile telecommunications regulatory requirements
      for pricing transparency and opt-in business rules for the country in
      which the service is offered. The user experience of the Life service is
      confirmed by the Mobile Network Operator with the applicable
      Telecommunications Regulator prior to the commercial deployment of the
      service in the country.
      <br />
      <br />
      <strong>
        CHOICES AVAILABLE TO YOU REGARDING DISPLAY OF AND ACCESS TO YOUR
        INFORMATION
      </strong>
      <br />
      OnePIN operates on a permission-only basis with respect to the publication
      of members' personal information. For the Life service, if your contact
      information (business card) changes, or if you no longer desire our
      service, you may correct, update, delete or deactivate it by accessing the
      services menu. A mobile subscriber's Life business card is accessible
      within the life.fun portal, defined for each mobile operator. The personal
      profile information in the Life business card can only be accessed and
      distributed by the subscriber (owner) by using the application on the
      subscriber's SIM card. When mobile subscribers use the Life service and
      choose to share their business card within another person, the sender's
      contact information may be stored in a secure cloud server environment.
      Members can send their contact information to any mobile subscriber. If a
      member chooses to send his or her contact information to another
      subscriber, non-members will receive the contact information in SMS (text)
      format with a link to the downloadable business card. Individuals who
      receive the text message displaying a sender's contact details do not need
      to click the Life link and download contact details if they do wish to
      include the sender's contact details in their device phonebook. Recipients
      are always in control of whether or not the sender's details are entered
      directly into the recipient's phonebooks. Further, a recipient always has
      the ability to delete any contacts added via Life, and no notifications
      are sent to the Sender that contact information was deleted. Members can
      choose to whom they send their contact information, one at a time, at the
      end of the first call to each unique mobile number. In this way, members
      have complete control over how much of their contact information is
      shared, and with whom this information is shared. Upon request OnePIN will
      provide you with information about whether we hold any of your personal
      information. You may access, correct, or request deletion of your personal
      information by contacting us at privacy@onepin.com. We will respond to
      your request within a reasonable timeframe.
      <br />
      <br />
      <strong>HOW TO CANCEL YOUR ACCOUNT</strong>
      <br />
      If a subscriber wishes to stop using the Life service, he/she may cancel
      the service via any of the following methods:
      <br />
      <ul>
        <li>
          By selecting the related OnePIN services submenu from Mobile Network
          Operator SIM services Menu, then selecting “turn off”;
        </li>
        <li>
          By sending an SMS with a keyword (e.g. STOP) to a specific number
          (number provided to the mobile subscriber via SMS, within the About
          screen of the SIM menu, and on the Mobile Network Operator’s website);
        </li>
        <li>
          By selecting and confirming an “automatic opt-out” notification
          displayed by the service if the mobile subscriber has chosen not to
          use the service after a period of time defined by the Mobile Network
          Operator (e.g. after choosing not to use the service after 5
          consecutive times).
        </li>
      </ul>
      <br />
      Under these circumstances, the Life service will no longer present itself
      when the subscriber makes phone calls. At any time, a subscriber can
      re-activate the account by visiting the services menu and selecting “turn
      on”. OnePIN will retain the contact information in the deactivated account
      until OnePIN's contract with the Mobile Network Operator expires or is
      terminated. OnePIN will retain and use subscriber information as necessary
      to comply with its legal obligations and in support of the agreement with
      the Mobile Network Operator.
      <br />
      <br />
      <strong>HOW THE INFORMATION IS USED</strong>
      <br />
      The contact information collected by the Life service belongs at all times
      to the individuals and organizations that entered the information. OnePIN
      claims no proprietary right whatsoever in the information and as such
      claims no right to use the information in any way other than for the
      purpose of operating the OnePIN services.
      <br />
      If you directly, or through OnePIN services, disclose your contact
      information to others, then your information may be collected and used by
      others.
      <br />
      <br />
      <strong>WHEN PERSONAL INFORMATION MAY BE DISCLOSED</strong>
      <br />
      In certain situations, OnePIN may be required to disclose personal data in
      response to lawful requests by public authorities, including to meet
      national security or law enforcement requirements. We may also disclose
      your personal information as required by law, such as to comply with a
      subpoena or other legal process, when we believe in good faith that
      disclosure is necessary to protect our rights, protect your safety or the
      safety of others, investigate fraud, or respond to a government request.
      <br />
      If OnePIN is involved in a merger, acquisition, or sale of all or a
      portion of its assets, your Mobile Network Operator will be notified via
      email and we will post a prominent notice on our Web site detailing any
      change in ownership.
      <br />
      <br />
      <strong>Third Party Intermediaries:</strong>
      <br />
      We may share aggregated information with companies that provide services
      such as hosting and IP routing for us to provide you service. These
      companies do not retain, share, store or use personal information gathered
      from OnePIN services for any secondary purposes. They are only authorized
      to use aggregated information only as necessary to provide the specified
      service. In order to provide the OnePIN services, the Mobile Network
      Operator network is used to transmit the information from one mobile
      subscriber to another. Mobile subscribers are protected under the terms of
      use of their Mobile Network Operator. The Mobile Network Operators do not
      retain, share, store or use personal information gathered from OnePIN
      services for any secondary purposes.
      <br />
      <br />
      <strong>Cookies and Other Tracking Technologies</strong>
      <br />
      Technologies such as cookies, tags and scripts are not used by OnePIN's
      mobile services. Other technologies are used in analyzing trends,
      administering the site, tracking subscribers' usage behaviors and to
      gather demographic information about our subscriber base as a whole. We
      may generate reports based on the use of these technologies on an
      individual as well as aggregated basis. We use technologies to remember
      subscribers' settings (e.g. language preference).
      <br />
      <br />
      <strong>Log files</strong>
      <br />
      Like most standard technology companies, OnePIN uses log files. Data
      collected includes MSISDN, mobile device type, platform and mobile OS
      type, date/time stamp, and number of clicks in order to analyze trends,
      administer the site, track subscribers' user behavior in the aggregate,
      and gather broad demographic information for aggregate use. OnePIN does
      not share this collected information with any third parties. We do not
      link the information we store within the analytics software to any
      personally identifiable information you submit within the mobile
      application. In order to provide the OnePIN services, the Mobile Network
      Operator network is used to transmit the information from one mobile
      subscriber to another. Mobile operators use log files, mandated by
      Telecommunications Regulations of the country (i.e. billing logs). Mobile
      subscribers are protected under the terms of use of their Mobile Network
      Operator. We do not link the information we store within the analytics
      software to any personally identifiable information you submit within the
      mobile application.
      <br />
      <br />
      <strong>COMMUNICATION BETWEEN ONEPIN AND USERS</strong>
      <br />
      <strong>Special Offers and Updates</strong>
      <br />
      After the provisioning of your SIM card for the first time, OnePIN sends
      all new subscribers a welcome communication via SMS (text) message or in
      the form of a mobile application notification on the screen. This
      communication will include service pricing, opt-in and opt-out
      information. Established subscribers will occasionally receive information
      on products, services, and special deals.
      <br />
      <br />
      <strong>Service Announcements</strong>
      <br />
      On occasion it is necessary for OnePIN to send out a strictly
      service-related announcement. For instance, if our service is temporarily
      suspended for maintenance we might send a communication via SMS (text)
      message or in the form of a mobile application notification on the screen.
      Typically, the Mobile Network Operator will communicate service
      announcements directly to the mobile subscriber.
      <br />
      <br />
      <strong>Customer Service</strong>
      <br />
      The Mobile Network Operator performs customer service communications
      directly with the mobile subscriber.
    </>
  );
}
